import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { Dictionary } from 'lodash';
import styled from 'styled-components';
import { FeatureId } from '../../../../../../common/iam/access/feature-access/types';
import { useHasAccessToFeature } from '../../../hooks';
import { BouSpacingLevel, fluidVerticalPadding } from '../../../layout/bou-spacing';
import { downloadAsXlsx } from '../spreadsheet-to-excel';
import { DownloadAsExcel } from '../table-v2/render/default/download-as-excel';

export interface SheetRow {
  [key: string]: number | string;
}

interface Props {
  dataBySheet: Dictionary<SheetRow[]>;
  label?: string;
}

export function DownloadExcelLink(props: Props) {
  const linkEnabled = useHasAccessToFeature(FeatureId.DOWNLOAD_AS_EXCEL);
  if (!linkEnabled) {
    return <></>;
  }

  const { dataBySheet } = props;
  const currentTime = new Date();
  const timestamp = `${currentTime.getFullYear()}${
    currentTime.getMonth() + 1
  }${currentTime.getDate()}-${currentTime.getHours()}${currentTime.getMinutes()}${currentTime.getSeconds()}`;

  return (
    <Root>
      <DownloadAsExcel
        onClick={() => {
          downloadAsXlsx(dataBySheet, `data-${timestamp}`);
        }}
        id={E2eTestElementId.TABLE_DOWNLOAD_LINK}
        label={props.label || 'Download as Excel'}
      />
    </Root>
  );
}

const Root = styled.div`
  ${fluidVerticalPadding(BouSpacingLevel.MICRO)}
`;
